import { type BoardObjectResource, type BoardObjectsTransform } from './types'

/**
 * Index of the first item in `positions` with a value ≥ the given `position`, falling back to the array length.
 *
 * @note If the given `position` is negative and `positions` is non-empty this will return `0`.
 */
export const indexForPosition = (positions: number[], position: number) => {
  const index = positions.findIndex((existing) => existing >= position)
  return index === -1 ? positions.length : index
}

export const insertBoardObject =
  (boardObject: BoardObjectResource): BoardObjectsTransform =>
  (draft) => {
    const index = indexForPosition(
      draft.data.map((existing) => existing.attributes.position),
      boardObject.attributes.position
    )
    draft.data.splice(index, 0, boardObject)
    return draft
  }
